import { useSystemStore } from '@/store/systemStore';

export function useActiveLanguages(): string[] {
  const settings = useSystemStore((s) => s.settings);
  return settings?.supported_languages ?? ['sl', 'en'];
}